var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("section", { staticClass: "section-declining-booking-hero" }, [
        _c("div", { staticClass: "declining-booking-hero-title text-center" }, [
          _c("h2", [_vm._v("มาเรียนรู้เทคนิคการปฏิเสธงานจากแม่บ้านชั้นครู")])
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "section-declining-booking-content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", [
              _vm._v("สวัสดีค่ะแพทตี้ แม่บ้านชั้นครูจาก BeNeat แบบไม่ได้อวยค่ะ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          คุณแม่บ้านหลายท่านอาจยังไม่ชำนาญเรื่องการจัดการคิวงานที่คุณลูกค้าจองมา แพทตี้อยากจะบอกว่าเรามีวิธีจัดการคิวงานได้หลายวิธีค่ะ แม้ว่างานที่เข้ามา เราดูรายละเอียดงานแล้วรู้สึกว่าไม่สะดวกรับ เช่น อาจไม่ว่างในวันเวลานั้น หรือสถานที่ไกลไปไม่สะดวก\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          แต่อย่าเพิ่งด่วนตัดสินใจจากความรู้สึกค่ะ เพราะโอกาสเข้ามาแล้วอย่าปล่อยให้หลุดมือ ทางแพทตี้เองได้มีโอกาสพูดคุยกับแม่บ้านระดับท็อปซุปเปอร์มาร์เก็ตของ BeNeat และเห็นว่าหลายท่านมีเทคนิคที่น่าสนใจ จึงนำมาแชร์ให้ลองเอาไปใช้กันดูค่ะ\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", [
              _vm._v(
                "คุณลูกค้าจองมา แต่ไม่ฉันสะดวกรับงาน? ปฏิเสธทันทีไม่ดีแน่!!"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          เจอแบบนี้อย่าเพิ่งกดปฏิเสธงานทันทีนะคะ โอกาสยังเป็นของเราอยู่ค่ะ คุณลูกค้าจองเรามาแล้ว ด้วยการฝ่าด่านอรหันต์ทั้ง 4 จากเว็บ BeNeat ถึงแม้จะไม่สะดวกเรื่องวันและเวลา แต่เรายังมีสิทธิความเป็นเจ้าของในงานนั้นค่ะ ให้ใช้โอกาสนี้ลองติดต่อกับคุณลูกค้าเพื่อทำการเจรจาต่อรอง ขอยกตัวอย่างเทคนิคที่แพทตี้ใช้นะคะ\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                '\n          "สวัสดีค่ะคุณลูกค้า… แพทตี้นะคะ (แนะนำตัวเองเบา ๆ) ที่คุณลูกค้าจองงานไว้ในวันที่...เวลา… แพทตี้ต้องขออภัยด้วยที่จะไม่สะดวกรับงานได้ในวัน หรือเวลาดังกล่าวค่ะ แพทตี้อยากรับงานนะคะ แต่เนื่องจากติดธุระในวัน หรือเวลานั้นจริง ๆ ค่ะ คุณลูกค้าจะกรุณาพิจารณาเป็นวัน หรือเวลาอื่นได้ไหมคะ ถ้าคุณลูกค้าสะดวกเลื่อนวัน หรือเวลา แพทตี้ยินดีไปให้บริการคุณลูกค้าค่ะ"\n        '
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          แต่ถ้าคุณลูกค้าไม่สะดวกเลื่อนวัน หรือเวลาใช้บริการ แพทตี้จะแจ้งว่าคุณลูกค้าสามารถกดในแอพหรือเว็บ เพื่อให้ BeNeat ช่วยหาคุณแม่บ้านท่านอื่นที่สะดวกรับงานแทนแพทตี้ได้นะคะ โดยคุณลูกค้าไม่จำเป็นต้องกดยกเลิกงานให้เสียค่าธรรมเนียมบัตรเครดิตเล่นค่ะ\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", [
              _vm._v(
                "คุณลูกค้าจองจำนวนชั่วโมงน้อยกว่าขนาดของที่พัก ก็อย่าเพิ่งกังวลค่ะ"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "โอ้โห หมูสามชั้น เอ้ยบ้าน 2-3 ชั้น ทำไมคุณลูกค้าจองมาแค่ 2-3 ชั่วโมงเนี่ย? ทำไม่ทันแน่ๆ เลย!!"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          เจอแบบนี้อย่าเพิ่งใจร้อนกดปฏิเสธงานนะค่ะ ให้ตรวจสอบรายละเอียดงานกับคุณลูกค้าแล้วค่อยพิจารณาอีกทีก็ได้ค่ะ โดยเราสามารถโทรหาคุณลูกค้าเพื่อสอบถามรายละเอียดเพิ่มเติมว่าที่คุณลูกค้าจองจำนวนชั่วโมงเข้ามาน้อยนั้น ทางคุณลูกค้าต้องการให้แม่บ้านทำความสะอาดเฉพาะบริเวณใช่หรือไม่ หรือต้องทำทั่วทุกบริเวณ\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          ที่ต้องถามก่อน เพราะมีคุณลูกค้าหลายท่านต้องการให้เราช่วยทำความสะอาดเพียงบางส่วนเท่านั้น หรือหากสอบถามแล้ว ปริมาณงานมากเกินกว่าจะทำเสร็จตามจำนวนชั่วโมงที่จองมา เราก็ใช้โอกาสนี้ในการเจรจากับคุณลูกค้าค่ะ ชี้แจงให้คุณลูกค้าเข้าใจ และช่วยคุณลูกค้าในการพิจารณาจำนวนชั่วโมงงานที่เหมาะสมได้ ยกตัวอย่างวิธีเจรจาที่แพทตี้ใช้นะคะ\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                '\n          "สวัสดีค่ะคุณลูกค้า แพทตี้ได้รับการจองของคุณลูกค้าเข้ามา คุณลูกค้าต้องการใช้บริการในวันที่...เวลา...จำนวน...ชั่วโมงนะคะ ลักษณะสถานที่เป็น…(ทวนรายละเอียดสถานที่ว่าเป็นบ้าน/คอนโด กี่ห้อง)\n          แพทตี้รบกวนสอบถามเพิ่มเติมค่ะ ว่าคุณลูกค้าต้องการให้ช่วยทำความสะอาดเป็นบางส่วนหรือเปล่าคะ"\n        '
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                '\n          "เนื่องจากจำนวนชั่วโมงที่คุณลูกค้าจองมา ไม่น่าจะเพียงพอสำหรับการทำความสะอาดทั่วบริเวณค่ะ หากคุณลูกค้าต้องการให้แพทตี้ช่วยทำความสะอาดทุกส่วน แพทตี้รบกวนให้ช่วยพิจารณาเพิ่มชั่วโมงงานให้ประมาณ … ชั่วโมงค่ะ ซึ่งน่าจะเพียงพอกับปริมาณงานที่ต้องให้แพทตี้ช่วยดูแลทำความสะอาดให้ทั่วบริเวณ เพื่องานจะได้เสร็จเรียบร้อยครอบคลุมทุกส่วนที่คุณลูกค้าต้องการค่ะ"\n        '
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", [
              _vm._v("ที่พักของคุณลูกค้าอยู่ซะไกล ไม่สะดวกใจจะรับงานเลย")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "ตรงนี้อย่าเพิ่งปิดโอกาสนะคะ ไกลหน่อยไม่เป็นไร ให้ลองโทรคุยกับคุณลูกค้าสักนิด เพราะคุณลูกค้าของ BeNeat หลายท่านที่มีบ้านหรือคอนโดหลายแห่ง จึงเป็นไปได้ว่าในอนาคตอาจได้มีโอกาสเรียกใช้บริการกันค่ะ หากที่พักนั้นอยู่ใกล้กับพื้นที่ที่เราให้บริการ"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "หากแต่ระยะทางของที่พักนั้นไกลจริง ๆ เราสามารถชี้แจงเรื่องความไม่สะดวกในการเดินทาง จึงต้องขออนุญาตปฏิเสธงานนี้ และขอส่งต่องานให้กับคุณแม่บ้านท่านอื่นที่พร้อมรับค่ะ"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", [_vm._v("สรุปแล้วลองคุยกับคุณลูกค้าก่อนดีอย่างไร")]),
            _vm._v(" "),
            _c("p", [
              _c("ul", { staticClass: "maininfo-list" }, [
                _c("li", [
                  _vm._v(
                    "ช่วยเปิดโอกาสให้คุณแม่บ้านได้รับงานนั้น ๆ ไว้เอง หากคุณลูกค้าสะดวกเลื่อนวันหรือเวลาใช้บริการ"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n            ถึงแม้คุณลูกค้าไม่สะดวกเลื่อนวันหรือเวลาในครั้งนี้ คุณลูกค้าอาจจะเรียกใช้บริการกับคุณแม่บ้านในครั้งต่อไป เพราะความใส่ใจในการให้บริการ\n          "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("ช่วยคุณแม่บ้านได้รักษาฐานคุณลูกค้าของตนเอง")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("ไม่เสียลูกค้าที่น่ารักจากระบบ BeNeat")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "มีโอกาสในการนำเสนอการขาย เพื่อให้คุณลูกค้าใช้บริการเป็นประจำ"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n            คุณลูกค้าบางท่านมีที่พักหลายแห่งที่ต้องการใช้เป็นประจำ ทำให้โอกาสที่คุณแม่บ้านจะได้รับงานทำความสะอาดที่พักอื่นที่อยู่ใกล้พื้นที่ของคุณแม่บ้านเองมีมากขึ้น\n          "
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdad4e4e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdad4e4e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/DecliningBooking.vue
// module id = 1527
// module chunks = 0